export enum apiUrls {
	crm = 'crm/api/',
	oms = 'core/api/',
	option = 'option/api/',
	algo = 'algo/api/order',
	algoHistory = 'algo/api/order-history',
	symbol = 'symbols/api/',
	easy = 'easy/api/',
	ipg = 'ipg/api/',
	portfolio = 'portfolio/api/',
	marketSheet = 'ms/api/MarketSheet/',
	fund = 'fund/api/',
	wallet = 'mofidcard/api/',
	tbs = 'tbs/api/',
	assets = 'assetmodule/api/',
	contract = 'contract/api/',
	marketreport = 'marketreport/api/'
}
